import api from './api';

// Admin API endpoints
export const adminAPI = {
  // Users - standardized CRUD methods for useCrudOperations hook
  users: {
    getAll: async () => {
      const response = await api.get('/admin/users');
      return response.data;
    },
    create: async (data) => {
      const response = await api.post('/admin/users', data);
      return response.data;
    },
    update: async (id, data) => {
      const response = await api.put(`/admin/users/${id}`, data);
      return response.data;
    },
    delete: async (id) => {
      const response = await api.delete(`/admin/users/${id}`);
      return response.data;
    },
  },

  // API Keys - standardized CRUD methods for useCrudOperations hook
  apiKeys: {
    getAll: async () => {
      const response = await api.get('/admin/api-keys');
      return response.data;
    },
    create: async (data) => {
      const response = await api.post('/admin/api-keys', data);
      return response.data;
    },
    update: async (id, data) => {
      // API keys don't support update, but required for CRUD interface
      throw new Error('API keys cannot be updated');
    },
    delete: async (id) => {
      const response = await api.delete(`/admin/api-keys/${id}`);
      return response.data;
    },
  },

  // Metric Definitions
  getAllMetricDefinitions: async () => {
    const response = await api.get('/admin/metrics/definitions');
    return response.data;
  },

  createMetricDefinition: async (data) => {
    const response = await api.post('/admin/metrics/definitions', data);
    return response.data;
  },

  updateMetricDefinition: async (id, data) => {
    const response = await api.put(`/admin/metrics/definitions/${id}`, data);
    return response.data;
  },

  deleteMetricDefinition: async (id) => {
    const response = await api.delete(`/admin/metrics/definitions/${id}`);
    return response.data;
  },

  // User Management
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  createUser: async (username, email, password, fullName, role, companyIds) => {
    const response = await api.post('/admin/users', {
      username,
      email,
      password,
      fullName,
      role,
      companyIds
    });
    return response.data;
  },

  updateUser: async (userId, data) => {
    const response = await api.put(`/admin/users/${userId}`, data);
    return response.data;
  },

  getUserCompanies: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/companies`);
    return response.data;
  },

  updateUserCompanies: async (userId, companyIds) => {
    const response = await api.put(`/admin/users/${userId}/companies`, { companyIds });
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  },

  updateUserRole: async (userId, role) => {
    const response = await api.put(`/admin/users/${userId}/role`, { role });
    return response.data;
  },

  getUserDashboards: async (userId) => {
    const response = await api.get(`/admin/users/${userId}/dashboards`);
    return response.data;
  },

  updateUserDashboards: async (userId, dashboardIds) => {
    const response = await api.put(`/admin/users/${userId}/dashboards`, { dashboardIds });
    return response.data;
  },

  // API Key Management
  getAllApiKeys: async () => {
    const response = await api.get('/admin/api-keys');
    return response.data;
  },

  createApiKey: async (keyName, companyId, expiresAt = null) => {
    const response = await api.post('/admin/api-keys', { keyName, companyId, expiresAt });
    return response.data;
  },

  deleteApiKey: async (id) => {
    const response = await api.delete(`/admin/api-keys/${id}`);
    return response.data;
  },

  toggleApiKey: async (id) => {
    const response = await api.put(`/admin/api-keys/${id}/toggle`);
    return response.data;
  },
};

export default adminAPI;
